"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const serialization_error_1 = require("../errors/serialization_error");
const primitive_serializer_1 = require("./primitive_serializer");
class BooleanSerializer extends primitive_serializer_1.default {
    /*override*/ expectPrimitiveOrNil(value) {
        if (typeof (value) === 'boolean') {
            return value;
        }
        else if (value instanceof Boolean) {
            return value.valueOf();
        }
        else if (value === null || value === undefined) {
            return value;
        }
        else {
            throw new serialization_error_1.default(`Property "${this.propertyName}" (typeof: "${typeof (value)}", value: "${value}") is not a boolean`);
        }
    }
}
exports.default = BooleanSerializer;
//# sourceMappingURL=boolean_serializer.js.map